// ============================================================================
// HOOK: useClientFlyout — Controle do flyout de documentos
// ARQUIVO: src/hooks/useClientFlyout.js
// RESPONSABILIDADE: Isolar estado do flyout compartilhado entre tabs.
// ============================================================================

import { useState, useCallback } from 'react';

export function useClientFlyout() {
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [flyoutOpen, setFlyoutOpen] = useState(false);
  const [consentFeedback, setConsentFeedback] = useState('');
  const [consentSaving, setConsentSaving] = useState(false);

  const openFlyout = useCallback((row) => {
    setConsentFeedback('');
    setSelectedDoc(row);
    setFlyoutOpen(true);
  }, []);

  const closeFlyout = useCallback(() => {
    setConsentFeedback('');
    setFlyoutOpen(false);
  }, []);

  return {
    selectedDoc,
    setSelectedDoc,
    flyoutOpen,
    setFlyoutOpen,
    consentFeedback,
    setConsentFeedback,
    consentSaving,
    setConsentSaving,
    openFlyout,
    closeFlyout,
  };
}
